import { Alert, Snackbar } from "@mui/material";
import { createContext, useContext, useState } from "react";

// src/context/NotificationContext.tsx
interface Notification {
  message: string;
  severity: "success" | "error" | "warning" | "info";
}

interface NotificationContextType {
  notify: (message: string, severity?: Notification["severity"]) => void;
}

const NotificationContext = createContext<NotificationContextType | null>(null);

export const NotificationProvider = ({ children }: { children: React.ReactNode }) => {
  const [notification, setNotification] = useState<Notification | null>(null);
  const [open, setOpen] = useState(false);

  const notify = (message: string, severity: Notification["severity"] = "success") => {
    setNotification({ message, severity });
    setOpen(true);
  };

  return (
    <NotificationContext.Provider value={{ notify }}>
      {children}
      <Snackbar
        open={open}
        autoHideDuration={3000}
        onClose={() => setOpen(false)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          severity={notification?.severity}
          onClose={() => setOpen(false)}
        >
          {notification?.message}
        </Alert>
      </Snackbar>
    </NotificationContext.Provider>
  );
};

export const useNotify = () => {
  const ctx = useContext(NotificationContext);
  if (!ctx) throw new Error("useNotify must be used inside NotificationProvider");
  return ctx.notify;
};